import type { RouteObject } from "react-router-dom";
import Loadable from "../../components/others/load/Loadable";
import RedgerlabWrapper from "./pages/RedgerlabWrapper";
import "./i18n";

const RedgerlabPatientsPage = Loadable(() => import("./pages/RedgerlabPatientsPage"));

const redgerlabRoutes: RouteObject = {
    path: "/redgerlab",
    element: <RedgerlabWrapper />,
    children: [
        {
            path: "patients",
            element: <RedgerlabPatientsPage />,
        },
    ],
};

export default redgerlabRoutes;
